
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import StoreSearch from "../pages/store-search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/store-search",
    element: <StoreSearch />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
